import Button, {
  ButtonProps,
  DeleteButton,
  EditButton,
} from "@/shared/form/button";
import { DeleteButtonProps } from "@/shared/form/button/delete-button/delete-button";
import Dropdown, { DropdownProps } from "@/shared/navigation/dropdown";
import { MoreOutlined } from "@ant-design/icons";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { useTranslations } from "use-intl";

export type MoreProps = DropdownProps & {
  buttonProps?: ButtonProps;
  "data-testid"?: string;
};

export function More({
  buttonProps,
  "data-testid": testId,
  ...rest
}: MoreProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={["click"]}
      overlayClassName={twMerge(
        "[&_.ant-dropdown-menu-item]:!p-0",
        "[&_button]:!text-left [&_button]:!justify-start [&_button]:!w-full",
      )}
      placement="bottomRight"
      {...rest}
    >
      <Button
        color="default"
        variant="outlined"
        className={"hover:!bg-[--palette-primary-1]"}
        icon={<MoreOutlined />}
        data-testid={testId}
        {...buttonProps}
      />
    </Dropdown>
  );
}

function MoreButton({ children, ...rest }: ButtonProps) {
  return (
    <Button block className="!justify-start" type="link" {...rest}>
      {children}
    </Button>
  );
}

function Edit({ children, ...rest }: ButtonProps) {
  const t = useTranslations("Common");

  return (
    <EditButton block className="!justify-start" type="link" {...rest}>
      {children ?? t("Edit")}
    </EditButton>
  );
}

function Delete(props: DeleteButtonProps) {
  const t = useTranslations("Common");

  return (
    <DeleteButton block className="!justify-start" {...props} type="link">
      {t("Delete")}
    </DeleteButton>
  );
}

More.Edit = Edit;
More.Delete = Delete;
More.Button = MoreButton;
